import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 16px;
  box-sizing: border-box;
  z-index: 2000;
  font-family: Roboto, sans-serif;
`;

export const Modal = styled.div`
  background: #ffffff;
  border-radius: 12px;
  width: 100%;
  max-width: 520px;
  max-height: 90dvh;
  overflow-y: auto;
  padding: 28px 28px 24px;
  box-sizing: border-box;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
  position: relative;

  @media (max-width: 768px) {
    padding: 22px 18px 20px;
  }
`;

export const CloseX = styled.button`
  position: absolute;
  top: 12px;
  right: 14px;
  border: none;
  background: transparent;
  font-size: 22px;
  line-height: 1;
  color: #999;
  cursor: pointer;
  padding: 4px;

  &:hover {
    color: #555;
  }
`;

export const Title = styled.h2`
  margin: 0 0 6px;
  font-size: 20px;
  font-weight: 700;
  color: #222;
`;

export const Subtitle = styled.p`
  margin: 0 0 20px;
  font-size: 13px;
  line-height: 1.5;
  color: #777;
`;

export const Section = styled.div`
  margin-bottom: 18px;
`;

export const FieldLabel = styled.label`
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #444;
  margin-bottom: 6px;
`;

export const EmailRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f4f6f8;
  border: 1px solid #e4e8ec;
  border-radius: 8px;
  padding: 10px 12px;
`;

export const EmailText = styled.span`
  flex: 1;
  font-size: 14px;
  font-weight: 600;
  color: #222;
  user-select: all;
  word-break: break-all;
`;

export const StyledInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  font-size: 14px;
  font-family: Roboto, sans-serif;
  color: #222;
  border: 1px solid #e4e8ec;
  border-radius: 8px;
  outline: none;

  &:focus {
    border-color: #61cbc9;
  }
`;

export const MessageBox = styled.textarea`
  width: 100%;
  box-sizing: border-box;
  min-height: 150px;
  resize: vertical;
  padding: 12px;
  font-size: 13px;
  line-height: 1.6;
  font-family: Roboto, sans-serif;
  color: #444;
  background: #fafbfc;
  border: 1px solid #e4e8ec;
  border-radius: 8px;
  outline: none;
`;

export const ActionRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 12px;
`;

/* 全域 Button.css 有一條 `button:hover { background-color:#fff; opacity:.5 }`，
   會套用到 app 裡所有 <button>。它的特異度 (0,1,1) 高於本檔按鈕的 rest 樣式 (0,1,0)，
   所以 hover 時會把背景蓋成白色（主按鈕白底白字 → 看起來消失）。
   對策：每個 &:hover 都把自己的背景色再宣告一次；`.hash:hover` (0,2,0) 會贏過全域規則。 */
const buttonBase = `
  flex: 1 1 140px;
  padding: 11px 14px;
  font-size: 14px;
  font-weight: 600;
  font-family: Roboto, sans-serif;
  border-radius: 8px;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  box-sizing: border-box;
  transition: opacity 0.15s ease;
`;

export const PrimaryButton = styled.button`
  ${buttonBase}
  background: #61cbc9;
  color: #ffffff;
  border: none;

  &:hover {
    background: #61cbc9;
    opacity: 0.85;
  }
`;

export const SecondaryButton = styled.button`
  ${buttonBase}
  background: #ffffff;
  color: #444;
  border: 1px solid #d9dee3;

  &:hover {
    background: #ffffff;
    opacity: 0.85;
  }
`;

/* mailto 用真正的 <a>，避免 Windows 上 window.location 改成 mailto 時整頁卡住 */
export const MailAppLink = styled.a`
  ${buttonBase}
  background: #ffffff;
  color: #444;
  border: 1px solid #d9dee3;
  display: inline-block;
  line-height: 1.2;

  &:hover {
    background: #ffffff;
    opacity: 0.85;
  }
`;

export const InlineButton = styled.button`
  border: 1px solid #d9dee3;
  background: #ffffff;
  color: #444;
  font-size: 12px;
  font-weight: 600;
  font-family: Roboto, sans-serif;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    opacity: 0.85;
  }
`;

export const Hint = styled.p`
  margin: 12px 0 0;
  font-size: 12px;
  line-height: 1.5;
  color: #999;
`;

export const CopiedTag = styled.span`
  display: inline-block;
  margin-left: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #2fae86;
`;
